import { Badge, ChevronDownIcon, cn, Paragraph } from '@quickmd-llc/design-system'
import React, { useMemo, useState } from 'react'
import { type WaitingRoomV2VisitListItemDoctorApiOutContract } from 'api/generated/pwrdbyQuickMDProvidersApi.schemas'
import { PatientRow } from './PatientRow'
import { groupVisitsByPreviousAndToday } from '../utils'

export const IncompleteSection: React.FC<{
  list: WaitingRoomV2VisitListItemDoctorApiOutContract[]
  onPrepVisitClick: (visit: WaitingRoomV2VisitListItemDoctorApiOutContract) => void
  hideHeader?: boolean
}> = ({ list, onPrepVisitClick, hideHeader = false }) => {
  const [isExpanded, setIsExpanded] = useState(true)
  const grouped = useMemo(() => groupVisitsByPreviousAndToday(list), [list])
  const availableCount = useMemo(() => list.filter((v) => v.IsPatientAvailable).length, [list])
  const expanded = hideHeader ? true : isExpanded

  return (
    <section>
      {!hideHeader && (
        <div
          role='button'
          tabIndex={0}
          aria-expanded={isExpanded}
          className='flex min-h-sp-6 cursor-pointer items-center gap-sp-1 py-sp-1'
          onClick={() => setIsExpanded((prev) => !prev)}
          onKeyDown={(e: React.KeyboardEvent) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              setIsExpanded((prev) => !prev)
            }
          }}>
          <ChevronDownIcon
            className={cn('text-text-light transition-transform', !isExpanded && '-rotate-90')}
            iconSize='xs'
          />
          <Paragraph className='font-semibold text-text-dark'>Incomplete</Paragraph>
          <Badge size='s' variant='warning'>
            {list.length} remaining
          </Badge>
          {availableCount > 0 && (
            <Paragraph size='sm' className='font-semibold text-text-success'>
              {availableCount} {availableCount === 1 ? 'Patient' : 'Patients'} available
            </Paragraph>
          )}
        </div>
      )}
      {expanded ? <div className='overflow-hidden rounded-[8px] border border-border-medium bg-white'>
          {grouped.length === 0 ?
            <div className='flex h-sp-6 w-full items-center justify-center px-sp-3 py-sp-1'>
              <Paragraph size='sm' className='text-text-light'>
                No incomplete patients.
              </Paragraph>
            </div>
          : grouped.map((section) => (
              <React.Fragment key={section.label}>
                {!(grouped.length === 1 && section.label === 'Today') && (
                  <div className='border-l-4 border-l-border-light bg-white px-sp-3 py-sp-1'>
                    <Paragraph className='font-semibold text-text-medium' size='sm'>
                      {section.label}
                    </Paragraph>
                  </div>
                )}
                {section.items.map((visit) => (
                  <PatientRow key={visit.VisitId} visit={visit} onClick={onPrepVisitClick} />
                ))}
              </React.Fragment>
            ))
          }
        </div> : null}
    </section>
  )
}
